import React from 'react';
import { isColumnsBlock, isLogosBlock, isPromoMainBlock, isResourcePreviewCardsBlock, isTabsBlock, isParallaxBlock, isHeroHomeBlock, isHighlightsBlock, isTitleBlock, isTwoColumnBlock } from '../types/typeGuards.ts';
import { PromoMainBlock } from '../blocks/PromoMainBlock/PromoMainBlock.tsx';
import { ColumnsBlock } from '../../redesign/blocks/ColumnsBlock/ColumnsBlock.tsx';
import TitleBlock from '../../redesign/blocks/TitleBlock/TitleBlock.tsx';
import { contentMapper } from './contentMapper.tsx';
import LogosBlock from '../blocks/LogosBlock/LogosBlock.tsx';
import Container from '../components/Container.tsx';
import ParallaxBlock from '../blocks/ParallaxBlock/ParallaxBlock.tsx';
import { TabsBlock } from '../blocks/TabsBlock/TabsBlock.tsx';
import ContainerNarrow from '../components/ContainerNarrow.tsx';
import { HeroHomeBlock } from '../blocks/HeroHomeBlock/HeroHomeBlock.tsx';
import HighlightsBlock from '../blocks/HightlightsBlock/HighlightsBlock.tsx';
import ResourcePreviewCardsBlock from '../blocks/ResourcePreviewCardsBlock/ResourcePreviewCardsBlock.tsx';
import { getBackgroundColor, getBorderColorByBgColor, getOutlineColorByBgColor } from './getColorClassName.tsx';
import { TwoColumnBlock } from '../blocks/TwoColumnBlock/TwoColumnBlock.tsx';
const TITLE_SQUARES_IMAGE = '/images/content-managed/squares/title-squares.svg';
const TABS_SQUARES_IMAGE = '/images/content-managed/squares/tabs-squares.svg';
const PARALLAX_SQUARES_IMAGE = '/images/content-managed/squares/parallax-squares.svg';
export const mapContentToBlock = (content) => {
    if (!content?.contentType) {
        return null;
    }
    if (isColumnsBlock(content)) {
        // TODO refactor this type recognition to avoid assertion
        const mappedContent = contentMapper(content, 'ColumnsBlock');
        const borderColorClass = getBorderColorByBgColor(mappedContent.blockBackgroundColor);
        const outlineColorClass = getOutlineColorByBgColor(mappedContent.blockBackgroundColor);
        return (React.createElement("div", { className: `${getBackgroundColor(mappedContent.blockBackgroundColor)} ${borderColorClass} border-t border-b` },
            React.createElement("div", { className: `mx-auto max-w-[1920px] outline-1 outline-solid ${outlineColorClass}` },
                React.createElement(ColumnsBlock, { items: mappedContent.items, blockBackgroundColor: mappedContent.blockBackgroundColor }))));
    }
    if (isTitleBlock(content)) {
        const mappedContent = contentMapper(content, 'TitleBlock');
        const squaresImage = mappedContent.hideSquaresImage
            ? {}
            : {
                squareImage: TITLE_SQUARES_IMAGE,
                squareContainerClasses: 'top-[-50px] lg:top-[-100px] left-0',
                squareImageClasses: 'h-[100px] lg:h-auto object-cover'
            };
        return (React.createElement(Container, { bgColor: mappedContent.backgroundColor, containerClasses: "relative", ...squaresImage },
            React.createElement(ContainerNarrow, null,
                React.createElement(TitleBlock, { content: mappedContent }))));
    }
    if (isLogosBlock(content)) {
        const mappedContent = contentMapper(content, 'LogosBlock');
        return (React.createElement(Container, { bgColor: mappedContent.backgroundColor },
            React.createElement(LogosBlock, { content: mappedContent })));
    }
    if (isTabsBlock(content)) {
        const mappedContent = contentMapper(content, 'TabsBlock');
        const squaresImage = mappedContent.hideSquaresImage
            ? {}
            : {
                squareImage: TABS_SQUARES_IMAGE,
                squareContainerClasses: 'top-[-25px] lg:top-[-50px] right-0',
                squareImageClasses: 'h-[75px] lg:h-auto object-cover'
            };
        return (React.createElement(Container, { bgColor: mappedContent.backgroundColor, containerClasses: "relative", ...squaresImage },
            React.createElement(TabsBlock, { content: mappedContent })));
    }
    if (isPromoMainBlock(content)) {
        const mappedContent = contentMapper(content, 'PromoMainBlock');
        return (React.createElement(Container, { bgColor: mappedContent.blockBackgroundColor },
            React.createElement(ContainerNarrow, null,
                React.createElement(PromoMainBlock, { content: mappedContent }))));
    }
    if (isParallaxBlock(content)) {
        const mappedContent = contentMapper(content, 'ParallaxBlock');
        const squaresImage = mappedContent.hideSquaresImage
            ? {}
            : {
                squareImage: PARALLAX_SQUARES_IMAGE,
                squareContainerClasses: 'top-[-25px] lg:top-[-51px] left-0',
                squareImageClasses: 'h-[75px] lg:h-auto object-cover'
            };
        return (React.createElement(Container, { bgColor: mappedContent.backgroundColor, containerClasses: "relative", ...squaresImage },
            React.createElement(ContainerNarrow, { classNames: "py-[60px] lg:pt-[134px] md:pb-0 lg:pb-0" },
                React.createElement(ParallaxBlock, { ...mappedContent }))));
    }
    if (isHeroHomeBlock(content)) {
        const mappedContent = contentMapper(content, 'HeroHomeBlock');
        return React.createElement(HeroHomeBlock, { ...mappedContent });
    }
    if (isHighlightsBlock(content)) {
        const mappedContent = contentMapper(content, 'HighlightsBlock');
        return (React.createElement(Container, null,
            React.createElement(ContainerNarrow, null,
                React.createElement(HighlightsBlock, { props: mappedContent }))));
    }
    if (isResourcePreviewCardsBlock(content)) {
        const mappedContent = contentMapper(content, 'ResourcePreviewCardsBlock');
        const squaresImage = mappedContent.hideSquaresImage
            ? {}
            : {
                squareImage: TABS_SQUARES_IMAGE,
                squareContainerClasses: 'top-[-25px] lg:top-[-50px] right-0',
                squareImageClasses: 'h-[75px] lg:h-auto object-cover'
            };
        return (React.createElement("div", { className: "relative" },
            React.createElement(Container, { bgColor: mappedContent.backgroundColor, containerClasses: "overflow-hidden", ...squaresImage },
                React.createElement(ContainerNarrow, null,
                    React.createElement(ResourcePreviewCardsBlock, { content: mappedContent })))));
    }
    if (isTwoColumnBlock(content)) {
        const mappedContent = contentMapper(content, 'TwoColumnBlock');
        return (React.createElement(Container, { bgColor: mappedContent.blockBackgroundColor },
            React.createElement(ContainerNarrow, { classNames: "pt-[20px] pb-[40px] md:pt-[50px] md:pb-[50px]" },
                React.createElement(TwoColumnBlock, { content: mappedContent }))));
    }
};
